export function gameWsUrl(sessionId, params) {
  const base = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws");
  const qs = new URLSearchParams(params).toString();
  return `${base}/api/games/ws/${sessionId}?${qs}`;
}
